import script from "./UserPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPanel.vue?vue&type=script&setup=true&lang=js"

import "./UserPanel.vue?vue&type=style&index=0&id=4f238b8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f238b8a"]])

export default __exports__